module.exports = __webpack_public_path__ + "static/flyingtilo-a1e438db8963eeb27de1afa6a51a5ada.gif";